import { createAsyncAction } from 'redux-promise-middleware-actions';

import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const assignCountProfileConstants = {
    ASSIGN_COUNT_PROFILE_LOADED: 'ASSIGN_COUNT_PROFILE_LOADED',
};

export const assignCountProfilePendingConstants = getActionTypesResult(assignCountProfileConstants, '_PENDING');
export const assignCountProfileFulfilledConstants = getActionTypesResult(assignCountProfileConstants, '_FULFILLED');
export const assignCountProfileRejectedConstants = getActionTypesResult(assignCountProfileConstants, '_REJECTED');

export const fetchAssignCountProfile = createAsyncAction(
    assignCountProfileConstants.ASSIGN_COUNT_PROFILE_LOADED,
    deviceId => api
        .get(`history/assignments/${deviceId}`)
        .then(res => ({ data: res.data, deviceId })),
    deviceId => deviceId
);
